import script from "./consolidated-payment-grid.vue?vue&type=script&setup=true&lang=ts"
export * from "./consolidated-payment-grid.vue?vue&type=script&setup=true&lang=ts"

import "./consolidated-payment-grid.vue?vue&type=style&index=0&id=3b083a78&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b083a78"]])

export default __exports__